
    import { mapGetters } from 'vuex'

    export default {
        props: {
          page: {
            type: Object,
            default() {
                return {}
            }
          },
        },
        data() {
          return {
            // Set true in mounted once we confirm the summer-bundles campaign is live
            summerBundlesActive: false,
            summerVirtualActive: false,
          }
        },
        computed: {
          ...mapGetters({
            detectedRegion: 'geolocation/region',
            userRegion: 'user/region',
          }),
          region() {
            return this.userRegion === 'default' ? this.detectedRegion : this.userRegion
          },
          // URL is always /courses/bundles/...
          isBundlesPage() {
            return this.$route.path.includes('/courses/bundles/')
          },
          isVirtualPage() {
            return this.$route.path.includes('/courses/virtual/') || this.$route.path.includes('/courses/combined/')
          },
          // Only true on the bundles page when summer-bundles is running
          showSummerBundles() {
            return this.isBundlesPage && this.summerBundlesActive
          },
          // Only true on the virtual courses page when summer-virtual is running
          showSummerVirtual() {
            return this.isVirtualPage && this.summerVirtualActive
          },
          headerImage() {
            // console.log('THUMBNAIL',thumbnail)
            const dotIndex = this.page.thumbnail.lastIndexOf('.');
            const ext = this.page.thumbnail.substring(dotIndex);
            const options = {quality:70, width: '700px'}
            if (ext === '.jpg' || ext === '.JPG' || ext === '.jpeg' || ext === '.JPEG' ){
              options.format = 'webp'
            }
            console.log('THUMBNAIL',this.page.thumbnail,options)
            const imgUrl = this.$img(this.$options.filters.cdn(this.page.thumbnail), options)
            return {
              backgroundImage: `url('${imgUrl}')`
            }
          },
        },
        mounted() {
          // $campaign is client-only, so confirm it exists before reading it
          if (this.$campaign && this.$campaign.isActive && this.$campaign.slug === 'summer-bundles') {
            const offer = this.$campaign.offerForRegion(this.region)
            if (offer && offer.offerText) {
              this.summerBundlesActive = true
            }
          }
          if (this.$campaign && this.$campaign.isActive && this.$campaign.slug === 'summer-virtual') {
            const offer = this.$campaign.offerForRegion(this.region)
            if (offer && offer.offerText) {
              this.summerVirtualActive = true
            }
          }
        }
    }
